
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discover",
      function () {
        return require("private-next-pages/discover/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discover"])
      });
    }
  